module.exports = __webpack_public_path__ + "img/jingshu.939610ed.png";